/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Drop_Zone_ChangeInputs */



/**
* | output |
* | --- |
* | "Click to choose a different file" |
*
* @param {New_Project_Drop_Zone_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_drop_zone_change = /** @type {((inputs?: New_Project_Drop_Zone_ChangeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Drop_Zone_ChangeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez pour choisir un autre fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicken Sie hier, um eine andere Datei auszuwählen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fai clic per scegliere un file diverso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нажмите, чтобы выбрать другой файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haz clic para elegir un archivo diferente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("点击选择其他文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("別のファイルを選択するにはクリックしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई दूसरी फ़ाइल चुनने के लिए क्लिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique para escolher um arquivo diferente.")
	return /** @type {LocalizedString} */ ("Click to choose a different file")
});